import * as Yup from 'yup';

export default Yup.object().shape({
  process: Yup.string().required('Process name is required'),
  // additional: Yup.string().required('Additional is required'),
  // filler: Yup.number()
  //   .required('Offset is required')
  //   .typeError('Offset must be number')
  //   .integer('Days save must be integer'),
});
